import { render } from "./Finalizado.vue?vue&type=template&id=7bf443f8&scoped=true"
import script from "./Finalizado.vue?vue&type=script&lang=js"
export * from "./Finalizado.vue?vue&type=script&lang=js"

import "./Finalizado.vue?vue&type=style&index=0&id=7bf443f8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf443f8"]])

export default __exports__